import React, { useEffect, useState } from 'react'

const PatientHistoryofdiagnosis = ({ diagnosis, diagnosisName, showDataIfNoteIsFollowUp, patientID, noteID, isAllotedToProvider, patientDiagnosis, noteStructureRef }) => {
  const [allQuestions, setAllQuestions] = useState([])
  useEffect(() => {
    if (noteStructureRef.current && noteStructureRef.current.historyOfDiagnosis) {
      const questions = noteStructureRef.current.historyOfDiagnosis[diagnosisName]
      setAllQuestions(questions)
    }
  }, [noteStructureRef, diagnosisName])
  return (
    <div>
      <div>
        <b className="">History of diagnosis </b>
      </div>
      {allQuestions && allQuestions.length > 0 ? (
        allQuestions.map((question, index) => (
          <div key={index}>
            <p>
              {question?.label}: <strong>{question?.answer ? question?.answer.split('|||').join(', ') : 'No Answer'} </strong>
              {question?.freeType && <span>"{question?.freeType}"</span>}
            </p>
          </div>
        ))
      ) : (
        <div className="d-flex justify-content-start align-items-start text-muted">
          <div
            style={{
              fontSize: '15px',
              fontWeight: '600px',
              color: 'gray',
            }}
          >
            No history of diagnosis available
          </div>
        </div>
      )}
      <hr />
    </div>
  )
}

export default PatientHistoryofdiagnosis
